(function () {
  'use strict'

  // eslint-disable-next-line no-undef
  angular.module('MktzapApp.Controllers').controller('ShowCompanyEmployerController', ShowCompanyEmployerController)

  ShowCompanyEmployerController.$inject = ['$rootScope', 'CompanyService', 'NotificationService']

  function ShowCompanyEmployerController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.companyEmployer')

    var vmShowCECtrl = this

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmShowCECtrl.metadata = data

        if (!('company_employer' in vmShowCECtrl.metadata.allow)) {
          vmShowCECtrl.metadata.allow.company_employer = false
        }
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta)
      })

    vmShowCECtrl.enable = function () {
      CompanyService
        .saveMetadata(vmShowCECtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data
          NotificationService.successHandler(data, $rootScope.labels.saveConfig)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig)
        })
    }

    vmShowCECtrl.getCanInactivateProfileControl = function () {
      if (!vmShowCECtrl.metadata.allow.permission_control) {
        CompanyService
          .getCanInactivateProfileControl()
          .$promise
          .then(function (data) {
            if (!data.status) {
              vmShowCECtrl.metadata.allow.permission_control = true;
              NotificationService.errorHandler(null, $rootScope.labels.cantInactivateProfileControlMessage);
              return;
            }

            vmShowCECtrl.enable();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
          })
        return;
      }

      vmShowCECtrl.enable();
    }
  }
// eslint-disable-next-line semi
})();
